<script lang="ts">
  import type { OrgaViewFrameContext } from "../../../../context"
  import type { PageContext } from "./context"
  import GeneralTab from "./tabs/General"
  import DangerTab from "./tabs/danger"
  import {
    canViewOrganizationSettings,
    canDeleteOrganization,
  } from "../../../../_shared/_logic/access"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: OrgaViewFrameContext
    activeTab: string
  }>()
  const pageContext = $derived<PageContext>({
    permissions: viewFrameContext.permissions,
    organization: viewFrameContext.organization,
    organizationId: viewFrameContext.organizationId,
    userOrganizationId: viewFrameContext.currentUserOrganizationId,
    voiceAllowed: viewFrameContext.voiceAllowed,
    isFreeTrialExperience: viewFrameContext.isFreeTrialExperience,
    currentUserOrganizationId: viewFrameContext.currentUserOrganizationId,
    canManageOrgSettings: viewFrameContext.permissions.allows("core.org_settings", "manage"),
    canDeleteOrganization: canDeleteOrganization(viewFrameContext),
    onOrganizationUpdated: viewFrameContext.onOrganizationUpdated,
    onDeleteOrganization: viewFrameContext.onDeleteOrganization,
  })
</script>

{#if activeTab === "general" && canViewOrganizationSettings(viewFrameContext)}
  <GeneralTab
    {pageContext}
    showChatWidget={viewFrameContext.tariffCapabilities.isKehrChat ||
      viewFrameContext.tariffCapabilities.isKehrTalk}
  />
{:else if activeTab === "danger" && pageContext.canDeleteOrganization}
  <DangerTab {pageContext} />
{/if}
